import jQuery from 'jquery';
import validation from 'jquery-validation';

jQuery(document).ready(function ($) {
    const btnLogin = '[js-login-btn]';
    const form = '[js-form-login]';
    const userLoginClass = '.user-login';
    const userPwdClass = '.user-password';
    const errorClass = '.error-field';
    const userRememberClass = '.user-remember';
    const loading = '.spinner';

    $(btnLogin).each(function (index) {
        $(this).click(function (e) {
            let currentForm = $(this).parents(form);
            let _this = $(this);

            function enableButton(){
                _this.prop("disabled",false);
            }

            $(currentForm).validate({
                submitHandler: function (form) {
                    let userLogin = $(currentForm).find(userLoginClass).val();
                    let userPassword = $(currentForm).find(userPwdClass).val();
                    let userRemember = $(currentForm).find(userRememberClass).val();
                    $(_this).prop("disabled",true);
                    $(loading).addClass('loading');
                    jQuery.post(
                        ajaxurl,
                        {
                            'action': 'ajax_login',
                            'contentType': "application/json; charset=utf-8",
                            'user_login': userLogin,
                            'user_password': userPassword,
                            'user_remember' : userRemember
                        },).fail(function (response) {
                    }).done(function (response) {
                        let jsonString = JSON.parse(response);

                        if (jsonString.code == 200) {
                            form.submit();
                        } else {
                            $(currentForm).find(errorClass).show();
                            if (jsonString.message == 'invalid_username') {
                                $(currentForm).find(errorClass).html('Votre identifiant n\'existe pas.');
                            } else if (jsonString.message == 'incorrect_password') {
                                $(currentForm).find(errorClass).html('Votre mot de passe est faux.');
                            }
                            $(loading).removeClass('loading');
                            enableButton();
                        }

                    }).always(function () {
                        $(loading).removeClass('loading');
                        enableButton();
                    });
                    return false;
                }
            });

            jQuery.extend(jQuery.validator.messages, {
                required: "Ce champ est requis."
            });

        });
    });
});